import { AttachableVCSIntegrationsOption } from "components/AttachableVCSIntegrationsOptions/types";
import ComboBoxHighlightText from "ds/components/ComboBox/HighlightText";
import ListBoxItem from "ds/components/ListBox/Item";
import Typography from "ds/components/Typography";

type SourceCodeIntegrationFieldComboBoxItemProps = AttachableVCSIntegrationsOption & {
  id: string;
  label: string;
};

const SourceCodeIntegrationFieldComboBoxItem = ({
  id,
  label,
  hasInstallations,
}: SourceCodeIntegrationFieldComboBoxItemProps) => {
  return (
    <ListBoxItem id={id} textValue={label}>
      <ComboBoxHighlightText text={label} />
      {hasInstallations === false && (
        <Typography tag="span" variant="p-body3" color="warning">
          Not installed
        </Typography>
      )}
    </ListBoxItem>
  );
};

export default SourceCodeIntegrationFieldComboBoxItem;
